import { IIndependentDiagnosticsGeneralRatingResponse } from 'api/types';

import { GET_INDEPENDENT_DIAGNOSTICS_GENERAL_RATING } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type IndependentDiagnosticsGeneralRatingState = IIndependentDiagnosticsGeneralRatingResponse;

const initialState: IndependentDiagnosticsGeneralRatingState = {
  content: undefined,
  loading: false,
};
const generic = genericReducers<IndependentDiagnosticsGeneralRatingState>();
const independentDiagnosticsGeneralRating: IReducers<IndependentDiagnosticsGeneralRatingState> = {
  [GET_INDEPENDENT_DIAGNOSTICS_GENERAL_RATING[REQUEST]]: generic.get.request,
  [GET_INDEPENDENT_DIAGNOSTICS_GENERAL_RATING[SUCCESS]]: generic.get.success,
  [GET_INDEPENDENT_DIAGNOSTICS_GENERAL_RATING[FAILURE]]: generic.get.failure,
  [GET_INDEPENDENT_DIAGNOSTICS_GENERAL_RATING[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, independentDiagnosticsGeneralRating);
